
(() => {
  const body = document.body;
  const layer = document.querySelector('[data-cart-layer]');
  const itemsHost = document.querySelector('[data-cart-items]');
  const subtotalHost = document.querySelector('[data-cart-subtotal]');
  const checkoutLink = document.querySelector('[data-cart-checkout]');
  const countHosts = [...document.querySelectorAll('[data-cart-count]')];

  const money = (cents) => new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY', maximumFractionDigits: 0 }).format(cents / 100);
  const escape = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[char]));

  function openCart() {
    if (!layer) return;
    layer.setAttribute('aria-hidden', 'false');
    body.classList.add('drawerOpen');
  }
  function closeCart() {
    if (!layer) return;
    layer.setAttribute('aria-hidden', 'true');
    body.classList.remove('drawerOpen');
  }
  async function refreshCart(open = false) {
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
    countHosts.forEach((host) => { host.textContent = String(cart.item_count); });
    if (itemsHost) {
      itemsHost.innerHTML = cart.items.length ? cart.items.map((item) => '<article class="cartLine"><div class="cartLineMedia">' + (item.image ? '<img src="' + escape(item.image) + '" alt="">' : '') + '</div><div><h3>' + escape(item.product_title) + '</h3><p>' + money(item.final_line_price) + '</p><span class="cartLineMeta">数量 ' + item.quantity + '</span><a class="cartLineRemove" href="/cart/change?id=' + encodeURIComponent(item.key) + '&quantity=0">削除</a></div></article>').join('') : '<p class="emptyCart">ショッピングバッグは空です。</p>';
    }
    if (subtotalHost) subtotalHost.textContent = money(cart.total_price);
    if (checkoutLink) checkoutLink.toggleAttribute('hidden', cart.item_count === 0);
    if (open) openCart();
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-cart-toggle]');
    const closer = event.target.closest('[data-cart-close]');
    if (toggle) { event.preventDefault(); refreshCart(true); }
    if (closer) { event.preventDefault(); closeCart(); }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-ajax-cart="true"]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (button) button.disabled = true;
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('add failed');
      await refreshCart(true);
    } catch (error) {
      window.location.href = '/cart';
    } finally {
      if (button) button.disabled = false;
    }
  });

  document.querySelectorAll('[data-category-filter]').forEach((button) => {
    button.addEventListener('click', () => {
      const category = button.dataset.categoryFilter;
      document.querySelectorAll('[data-category-filter]').forEach((candidate) => candidate.classList.toggle('active', candidate === button));
      document.querySelectorAll('[data-product-card]').forEach((card) => { card.hidden = category !== 'all' && !card.dataset.categories.split(' ').includes(category); });
      const label = document.querySelector('[data-active-category-label]');
      if (label) label.textContent = button.querySelector('span')?.textContent || 'ALL COLLECTIONS';
      document.getElementById('new')?.scrollIntoView({ behavior: 'smooth' });
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('.storyProductMainImage img');
    gallery.querySelectorAll('[data-gallery-src]').forEach((button) => button.addEventListener('click', () => {
      if (!main) return;
      main.src = button.dataset.gallerySrc;
      main.alt = button.dataset.galleryAlt || '';
      gallery.querySelectorAll('[data-gallery-src]').forEach((candidate) => {
        const active = candidate === button;
        candidate.classList.toggle('isActive', active);
        candidate.setAttribute('aria-pressed', String(active));
      });
    }));
  });
})();
